// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { utils } from '@seedplanner/shared-utils';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Table } from '../common/table';
import type { ColumnType } from '../common/table/Table';
import { CropIdLink } from '../crop';

interface DeficitInfo {
  readonly cropData: {
    readonly id: number;
    readonly cropName: string;
  };
  readonly traysNeeded: number;
  readonly traysAvailable: number;
  readonly traysDeficit: number;
}

interface Props {
  readonly deficits: DeficitInfo[];
  readonly useForBuffers?: boolean;
}

export default function OrderDeficitsTable({ deficits, useForBuffers }: Props) {
  const links: React.ReactElement[] = [];
  const traysNeeded: number[] = [];
  const traysAvailable: number[] = [];
  const traysDeficit: number[] = [];

  for (const deficit of deficits) {
    links.push(<CropIdLink id={deficit.cropData.id.toString()} name={deficit.cropData.cropName} />);
    traysNeeded.push(utils.round(deficit.traysNeeded));
    traysAvailable.push(utils.round(deficit.traysAvailable));
    traysDeficit.push(utils.round(deficit.traysDeficit) * (useForBuffers ? -1 : 1));
  }
  const columns: ColumnType[] = [
    {
      name: 'Crop',
      values: links,
    },
    {
      name: `Tray ${useForBuffers ? 'Buffer' : 'Deficit'}`,
      values: traysDeficit,
      numeric: true,
    },
    {
      name: 'Trays Needed',
      values: traysNeeded,
      numeric: true,
      visibleAt: 'sm',
    },
    {
      name: 'Trays Assigned',
      values: traysAvailable,
      numeric: true,
      visibleAt: 'sm',
    },
  ];

  return <Table columns={columns} />;
}
